export default __webpack_public_path__ + "static/media/press3.d0833bff.jpg";